<template>
  <div class="ott-faq-area pb-100">
    <div class="container">
      <div class="row justify-content-center align-items-center">
        <div
          class="col-xl-7 col-md-12"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="100"
        >
          <div class="ott-faq-image">
            <img src="@/assets/images/ott-platform/faq.png" alt="FAQ Image" />
            <div class="wrap-shape">
              <img
                src="@/assets/images/ott-platform/faq-shape.png"
                alt="Shape"
              />
            </div>
          </div>
        </div>

        <div
          class="col-xl-5 col-md-12"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div class="ott-faq-content">
            <h2 class="text-white">الأسئلة الشائعة</h2>
            <div class="accordion" id="accordionOTT">
              <div
                class="accordion-item"
                v-for="(faq, index) in faqs"
                :key="index"
                :class="{ active: activeIndex === index }"
              >
                <h2 class="accordion-header">
                  <button
                    class="accordion-button"
                    type="button"
                    :aria-expanded="activeIndex === index ? 'true' : 'false'"
                    @click="toggleAccordion(index)"
                  >
                    {{ faq.question }}
                  </button>
                </h2>
                <div
                  class="accordion-collapse collapse show"
                  v-show="activeIndex === index"
                >
                  <div class="accordion-body">
                    <p>{{ faq.answer }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "FrequentlyAskedQuestions",
  setup() {
    const activeIndex = ref<number>(0);

    const faqs = ref([
      {
        question: "ما هي الأجهزة التي يدعمها السيرفر؟",
        answer:
          "يدعم لوحة واسعة من الأجهزة؛ لا تحتاج إلى أي خبرة تقنية، فقط قم بتحميل التطبيق المخصص على شاشتك الذكية (Smart TV)، هاتفك المحمول، جهازك اللوحي، أو جهاز الحصوب واتبع خطوات التشغيل البسيطة.",
      },
      {
        question: "كيف يمكنني الحصول على الدعم الفني من loay iptv؟",
        answer:
          "فريق الدعم الفني لدينا متواجد لخدمتك على مدار الساعة؛ يمكنك التواصل معنا مباشرة عبر المحادثة الفورية على الموقع، أو من خلال الواتساب، أو عبر البريد الإلكتروني لضمان حل أي استفسار فوراً.",
      },
      {
        question: "كم من الوقت يستغرق تفعيل الاشتراك والبدء في المشاهدة؟",
        answer:
          "يتم تفعيل الخدمة وإرسال بيانات الاشتراك إليك بشكل فوري وآلي بمجرد إتمام عملية التسجيل وتأكيد الدفع، لتتمكن من بدء المشاهدة مباشرة.",
      },
      {
        question: "ما هي سياسة استرداد الأموال المتبعة؟",
        answer:
          "نحن نضمن لك الرضا الكامل، وفي حال واجهتك أي مشكلة تقنية خارجة عن الإرادة، تتيح لك سياستنا إلغاء الاشتراك واسترداد المبالغ المدفوعة بنسبة 100% خلال أول 24 ساعة من التفعيل.",
      },
      {
        question: "هل يمكنني تشغيل الاشتراك على أكثر من جهاز؟",
        answer:
          "نعم، يدعم السيرفر التشغيل على مختلف الأجهزة، ولكن عدد الأجهزة التي تعمل في نفس الوقت (بث متزامن) يعتمد على نوع الباقة التي اخترتها أثناء الاشتراك (Lite أو Ultra أو Pro).",
      },
    ]);

    const toggleAccordion = (index: number) => {
      activeIndex.value = activeIndex.value === index ? -1 : index;
    };

    return {
      activeIndex,
      toggleAccordion,
      faqs,
    };
  },
});
</script>